/* ==============================================================================
   LUZGURU PRODUCT COMPARISON SYSTEM - CORE LOGIC
   Asset: assets/lg-compare.js
   Supports global modal and dedicated /pages/comparar layout with URL sharing.
   ============================================================================== */

(function() {
  const STORAGE_KEY = 'lg-compare-products';
  const MAX_PRODUCTS = 3;

  // Escape para interpolar datos (títulos, URLs) dentro de innerHTML
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  window.lgEscapeHtml = esc;

  // Cache de elementos DOM
  let barEl, barCountEl, barItemsEl, clearBtn, submitBtn;
  let modalEl, modalCloseBtn, modalLoaderEl, tableWrapperEl;

  // Obtener lista actual de localStorage
  function getCompareList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  // Guardar lista en localStorage y sincronizar URL
  function saveCompareList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    syncToUrlQuery();
    window.dispatchEvent(new Event('lg:compare:updated'));
  }

  // Sincronizar desde la URL si hay parámetros (?items=handle-1,handle-2)
  function syncFromUrlQuery() {
    const urlParams = new URLSearchParams(window.location.search);
    const itemsParam = urlParams.get('items');
    if (itemsParam) {
      // Clean parameter immediately
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);

      const handles = itemsParam.split(',').map(h => h.trim()).filter(h => h.length > 0);
      if (handles.length > 0) {
        let list = getCompareList();
        let importedCount = 0;
        handles.forEach(handle => {
          if (!list.some(item => item.handle === handle)) {
            // Añadir temporalmente con títulos y avatares genéricos hasta cargarlos
            list.push({ 
              id: null, 
              handle: handle, 
              title: handle.replace(/-/g, ' ').toUpperCase(), 
              image: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="%23F8900B" stroke-width="1.2"><circle cx="12" cy="12" r="10"/><path d="M12 8v8M8 12h8"/></svg>' 
            });
            importedCount++;
          }
        });
        if (importedCount > 0) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
          showCompareImportBanner(importedCount);
        }
      }
    }
  }

  // Sincronizar hacia la URL si estamos en la página del comparador
  function syncToUrlQuery() {
    const isComparePage = window.location.pathname.includes('/pages/comparar') || window.location.pathname.includes('/pages/comparador');
    if (!isComparePage) return;
    
    const list = getCompareList();
    const handles = list.map(item => item.handle).join(',');
    const url = new URL(window.location);
    if (handles.length > 0) {
      url.searchParams.set('items', handles);
    } else {
      url.searchParams.delete('items');
    }
    window.history.replaceState({}, '', url.toString());
  }

  // Inicializar elementos DOM del widget
  function initDOM() {
    barEl = document.getElementById('lg-compare-bar');
    barCountEl = document.getElementById('lg-compare-bar-count');
    barItemsEl = document.getElementById('lg-compare-bar-items');
    clearBtn = document.getElementById('lg-compare-bar-clear');
    submitBtn = document.getElementById('lg-compare-bar-submit');

    modalEl = document.getElementById('lg-compare-modal');
    modalCloseBtn = document.getElementById('lg-compare-modal-close');
    modalLoaderEl = document.getElementById('lg-compare-modal-loader');
    tableWrapperEl = document.getElementById('lg-compare-table-wrapper');

    if (clearBtn) {
      clearBtn.addEventListener('click', clearAll);
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', () => {
        const isComparePage = window.location.pathname.includes('/pages/comparar') || window.location.pathname.includes('/pages/comparador');
        
        // Obtener la configuración de redirección desde el widget
        const widgetRoot = document.getElementById('lg-compare-widget-root');
        const usePageRedirect = widgetRoot ? widgetRoot.dataset.usePageRedirect === 'true' : false;

        if (usePageRedirect && !isComparePage && document.getElementById('lg-compare-page-body') === null) {
          // Obtener la raíz localizada de la tienda para evitar errores 404 (ej. /es/pages/comparar)
          const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const cleanRootUrl = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
          window.location.href = `${cleanRootUrl}pages/comparar?items=${getCompareList().map(i => i.handle).join(',')}`;
        } else {
          openComparisonModal();
        }
      });
    }

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', closeComparisonModal);
    }

    const overlay = document.querySelector('.lg-compare-modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', closeComparisonModal);
    }

    // Compare header link
    const headerCompareBtn = document.getElementById('compare-icon-bubble');
    if (headerCompareBtn) {
      headerCompareBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openComparisonModal();
      });
    }

    // Checkbox listener to show only differences (modal)
    const toggleOnlyDiffs = document.getElementById('lg-compare-only-diffs');
    if (toggleOnlyDiffs) {
      if (toggleOnlyDiffs.checked && tableWrapperEl) {
        tableWrapperEl.classList.add('lg-compare-show-differences-only');
      }
      toggleOnlyDiffs.addEventListener('change', function(e) {
        if (e.target.checked) {
          if (tableWrapperEl) tableWrapperEl.classList.add('lg-compare-show-differences-only');
        } else {
          if (tableWrapperEl) tableWrapperEl.classList.remove('lg-compare-show-differences-only');
        }
      });
    }

    // Checkbox listener to show only differences (page)
    const togglePageOnlyDiffs = document.getElementById('lg-compare-page-only-diffs');
    if (togglePageOnlyDiffs) {
      const pageTableWrapper = document.getElementById('lg-compare-page-table-wrapper');
      if (togglePageOnlyDiffs.checked && pageTableWrapper) {
        pageTableWrapper.classList.add('lg-compare-show-differences-only');
      }
      togglePageOnlyDiffs.addEventListener('change', function(e) {
        const pageTableWrapper = document.getElementById('lg-compare-page-table-wrapper');
        if (e.target.checked) {
          if (pageTableWrapper) pageTableWrapper.classList.add('lg-compare-show-differences-only');
        } else {
          if (pageTableWrapper) pageTableWrapper.classList.remove('lg-compare-show-differences-only');
        }
      });
    }

    // Escuchar cambios de estado para actualizar widgets
    window.addEventListener('lg:compare:updated', updateWidgets);
  }

  // Toast compartido: el wishlist lo reutiliza vía window.showCompareToast
  window.showCompareToast = function(message) { showCompareToast(message); };

  // Toast de confirmación — Look Gascón (blanco, borde dorado, sin radius)
  function showCompareToast(message) {
    let toastContainer = document.getElementById('lg-compare-toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.id = 'lg-compare-toast-container';
      toastContainer.style.cssText = 'position: fixed; bottom: 24px; right: 24px; z-index: 10000; display: flex; flex-direction: column; gap: 8px; pointer-events: none;';
      document.body.appendChild(toastContainer);
    }

    const toast = document.createElement('div');
    toast.className = 'lg-compare-toast';
    toast.style.cssText = [
      'background: #ffffff',
      'color: rgba(8,12,20,0.85)',
      'padding: 12px 20px',
      'border-radius: 0',                          /* Estricto Gascón */
      'border: 1px solid rgba(8,12,20,0.08)',
      'border-left: 3px solid #F8900B',            /* Dorado Luzguru */
      'font-size: 1.2rem',
      'font-weight: 400',
      'font-family: var(--font-body-family, sans-serif)',
      'letter-spacing: 0.03em',
      'box-shadow: 0 4px 20px rgba(0,0,0,0.06)',
      'display: flex',
      'align-items: center',
      'gap: 10px',
      'opacity: 0',
      'transform: translateY(8px)',
      'transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.16,1,0.3,1)',
      'pointer-events: auto',
      'min-width: 200px',
      'max-width: 320px'
    ].join('; ');
    toast.innerHTML = `
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F8900B" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      <span>${esc(message)}</span>
    `;
    toastContainer.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    }, 10);

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-6px)';
      setTimeout(() => toast.remove(), 350);
    }, 2800);
  }

  // Añadir un producto a la lista de comparación
  function addProduct(id, handle, title, image, button, variantId) {
    let list = getCompareList();

    // Validar si ya existe
    if (list.some(item => item.handle === handle)) {
      return false;
    }

    // Validar límite
    if (list.length >= MAX_PRODUCTS) {
      showCompareToast(`Límite alcanzado: Máximo ${MAX_PRODUCTS} productos.`);
      return false;
    }

    list.push({ id, handle, title, image, variantId: variantId || null });
    saveCompareList(list);
    
    if (button) {
      animateCompareAdd(button); // Trigger sophisticated flyer animation
    }
    return true;
  }

  // Quitar un producto de la lista
  function removeProduct(handle) {
    let list = getCompareList();
    list = list.filter(item => item.handle !== handle);
    saveCompareList(list);
  }

  // Limpiar toda la lista
  function clearAll() {
    saveCompareList([]);
    showCompareToast('Se ha limpiado la lista de comparación');
  }

  // Helper para renderizar miniaturas en la barra flotante
  function syncFloatingBarThumbnails(list) {
    if (barItemsEl) {
      barItemsEl.innerHTML = list.map(item => `
        <div class="lg-compare-bar-item" data-handle="${item.handle}">
          <img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">
          <button type="button" class="lg-compare-bar-item__remove" aria-label="Quitar ${esc(item.title)}">✕</button>
        </div>
      `).join('');

      barItemsEl.querySelectorAll('.lg-compare-bar-item__remove').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const itemEl = btn.closest('.lg-compare-bar-item');
          if (itemEl) {
            removeProduct(itemEl.dataset.handle);
          }
        });
      });
    }
    if (barCountEl) barCountEl.innerText = list.length;
  }

  // Actualizar estados visuales de los elementos y botones en toda la página
  // Actualizar estados visuales de los elementos y botones en toda la página
  function updateWidgets() {
    const list = getCompareList();
    const count = list.length;

    // 1. Sincronizar miniaturas en barra flotante inferior
    syncFloatingBarThumbnails(list);

    // 2. Controlar visibilidad de la barra flotante inferior
    if (barEl) {
      // Si estamos en la página dedicada de comparar, no mostramos la barra flotante
      const isComparePage = window.location.pathname.includes('/pages/comparar') || window.location.pathname.includes('/pages/comparador') || document.getElementById('lg-compare-page-body') !== null;
      
      if (count > 0 && !isComparePage) {
        barEl.classList.add('visible');
        barEl.removeAttribute('hidden');
      } else {
        barEl.classList.remove('visible');
        setTimeout(() => {
          if (getCompareList().length === 0 || isComparePage) {
            barEl.setAttribute('hidden', 'true');
          }
        }, 400);
      }
    }

    // 3. Sincronizar clases y estados en todos los botones de la página
    document.querySelectorAll('.lg-compare-btn-toggle, .lg-compare-card-btn').forEach(btn => {
      const handle = btn.dataset.handle;
      const isAdded = list.some(item => item.handle === handle);
      
      if (isAdded) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        
        const labelText = btn.querySelector('span');
        if (labelText) {
          labelText.innerText = 'Quitar de comparar';
        }
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
        
        const labelText = btn.querySelector('span');
        if (labelText) {
          labelText.innerText = 'Añadir a comparar';
        }
      }
    });

    // 4. Update Header bubble count
    const headerCompareBtn = document.getElementById('compare-icon-bubble');
    if (headerCompareBtn) {
      const compareCountBubble = headerCompareBtn.querySelector('.compare-count-bubble');
      if (compareCountBubble) {
        if (count > 0) {
          compareCountBubble.textContent = count;
          compareCountBubble.style.display = 'flex';
        } else {
          compareCountBubble.style.display = 'none';
        }
      }
    }

    // 5. Update modal header count badge
    const modalCountBadge = document.getElementById('lg-compare-count-badge');
    if (modalCountBadge) {
      modalCountBadge.textContent = count === 1 ? '1 producto' : `${count} productos`;
    }

    // 6. Update modal sharing footer
    const footerEl = document.getElementById('lg-compare-modal-footer');
    if (footerEl) {
      if (count > 0) {
        footerEl.style.display = 'block';
        setupSharing(list);
      } else {
        footerEl.style.display = 'none';
      }
    }

    // Update differences toggle container visibility
    const toggleContainer = document.getElementById('lg-compare-toggle-container');
    const toggleOnlyDiffs = document.getElementById('lg-compare-only-diffs');
    if (toggleContainer) {
      if (count > 1) {
        toggleContainer.style.display = 'flex';
        if (toggleOnlyDiffs && toggleOnlyDiffs.checked && tableWrapperEl) {
          tableWrapperEl.classList.add('lg-compare-show-differences-only');
        }
      } else {
        toggleContainer.style.display = 'none';
        if (toggleOnlyDiffs) {
          toggleOnlyDiffs.checked = true;
          if (tableWrapperEl) tableWrapperEl.classList.add('lg-compare-show-differences-only');
        }
      }
    }

    const pageToggleContainer = document.getElementById('lg-compare-page-toggle-container');
    const togglePageOnlyDiffs = document.getElementById('lg-compare-page-only-diffs');
    const pageTableWrapper = document.getElementById('lg-compare-page-table-wrapper');
    if (pageToggleContainer) {
      if (count > 1) {
        pageToggleContainer.style.display = 'flex';
        if (togglePageOnlyDiffs && togglePageOnlyDiffs.checked && pageTableWrapper) {
          pageTableWrapper.classList.add('lg-compare-show-differences-only');
        }
      } else {
        pageToggleContainer.style.display = 'none';
        if (togglePageOnlyDiffs) {
          togglePageOnlyDiffs.checked = true;
          if (pageTableWrapper) pageTableWrapper.classList.add('lg-compare-show-differences-only');
        }
      }
    }

    // 7. Si el modal está abierto, actualizarlo
    if (modalEl && modalEl.classList.contains('open')) {
      renderComparisonTable(list, tableWrapperEl, modalLoaderEl);
    }

    // 8. Si hay elementos en la página dedicada de comparación
    const pageEmpty = document.getElementById('lg-compare-page-empty');
    const pageLoader = document.getElementById('lg-compare-page-loader');
    
    if (pageTableWrapper && pageEmpty) {
      if (count > 0) {
        pageEmpty.setAttribute('hidden', 'true');
        pageTableWrapper.style.display = 'block';
        renderComparisonTable(list, pageTableWrapper, pageLoader);
      } else {
        pageEmpty.removeAttribute('hidden');
        pageTableWrapper.style.display = 'none';
        if (pageLoader) pageLoader.setAttribute('hidden', 'true');
      }
    }
  }

  // Abrir Modal de Comparación
  function openComparisonModal() {
    if (!modalEl) return;
    modalEl.classList.add('open');
    modalEl.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    const list = getCompareList();
    renderComparisonTable(list, tableWrapperEl, modalLoaderEl);
  }

  // Cerrar Modal de Comparación
  function closeComparisonModal() {
    if (!modalEl) return;
    modalEl.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => {
      if (!modalEl.classList.contains('open')) {
        modalEl.setAttribute('hidden', 'true');
      }
    }, 400);
  }

  // Consultar la API de Shopify y renderizar la tabla comparativa (Reutilizable para modal y página)
  async function renderComparisonTable(list, wrapperEl, loaderEl) {
    if (!wrapperEl || !loaderEl) return;

    if (list.length === 0) {
      wrapperEl.innerHTML = `
        <div class="lg-compare-empty" style="text-align: center; padding: 3rem 1.5rem; max-width: 500px; margin: 0 auto;">
          <div class="lg-compare-empty__icon" style="margin-bottom: 1.5rem; color: #F8900B;">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="3" width="8" height="18" rx="1"/>
              <rect x="14" y="3" width="8" height="18" rx="1"/>
              <path d="M10 12h4"/>
            </svg>
          </div>
          <h3 class="lg-compare-empty__title" style="font-family: 'Montserrat', sans-serif; font-size: 1.6rem; font-weight: 750; text-transform: uppercase; letter-spacing: 0.05em; color: #1a0f00; margin: 0 0 1rem 0;">Tu comparador está vacío</h3>
          <p class="lg-compare-empty__text" style="font-family: 'Inter', sans-serif; font-size: 1.25rem; color: #666; line-height: 1.4; margin: 0 0 2rem 0;">Añade hasta 3 productos para ver sus características técnicas frente a frente.</p>
          
          <div class="lg-compare-instructions" style="text-align: left; margin: 2rem 0; padding: 1.5rem; background: #faf9f6; border-radius: 8px; border: 1px solid rgba(248, 144, 11, 0.08);">
            <div class="lg-compare-instructions__item" style="display: flex; gap: 12px; margin-bottom: 1.5rem;">
              <span class="lg-compare-instructions__num" style="font-weight: bold; color: #F8900B; font-size: 1.4rem;">1</span>
              <div>
                <strong style="font-size: 1.25rem; color: #1a0f00; font-family: 'Montserrat', sans-serif;">¿Cómo usarlo?</strong>
                <p style="font-size: 1.15rem; color: #666; margin: 4px 0 0 0; line-height: 1.35;">Busca el icono de doble columna en las fotos de producto o en su ficha detallada para agregarlos.</p>
              </div>
            </div>
            <div class="lg-compare-instructions__item" style="display: flex; gap: 12px;">
              <span class="lg-compare-instructions__num" style="font-weight: bold; color: #F8900B; font-size: 1.4rem;">2</span>
              <div>
                <strong style="font-size: 1.25rem; color: #1a0f00; font-family: 'Montserrat', sans-serif;">Ventajas</strong>
                <p style="font-size: 1.15rem; color: #666; margin: 4px 0 0 0; line-height: 1.35;">Compara potencias (W), dimensiones, tonos de luz y grados de protección IP side-by-side de forma visual para acertar con tu compra.</p>
              </div>
            </div>
          </div>
          
          <div class="lg-compare-empty__actions" style="display: flex; gap: 12px; justify-content: center; margin-top: 1.5rem;">
            <a href="/collections/ventiladores-de-techo" class="button button--secondary" style="font-family: 'Montserrat', sans-serif; font-weight: 700; text-transform: uppercase; font-size: 1.1rem; padding: 1rem 1.5rem;">Ver Ventiladores</a>
            <a href="/collections/plafones" class="button button--secondary" style="font-family: 'Montserrat', sans-serif; font-weight: 700; text-transform: uppercase; font-size: 1.1rem; padding: 1rem 1.5rem;">Ver Plafones</a>
          </div>
        </div>
      `;
      loaderEl.setAttribute('hidden', 'true');
      wrapperEl.style.opacity = '1';
      return;
    }

    loaderEl.removeAttribute('hidden');
    wrapperEl.style.opacity = '0.3';

    try {
      const promises = list.map(item => {
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const cleanRootUrl = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
        const url = `${cleanRootUrl}products/${item.handle}?sections=product-compare-card${item.variantId ? '&variant=' + encodeURIComponent(item.variantId) : ''}`;
        return fetch(url)
          .then(res => {
            if (!res.ok) throw new Error(`Error cargando producto: ${item.handle}`);
            return res.json();
          })
          .then(json => {
            const htmlString = json['product-compare-card'];
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const scriptTag = doc.querySelector('script[data-compare-json]');
            if (!scriptTag) throw new Error(`Falta el tag JSON en producto: ${item.handle}`);
            const data = JSON.parse(scriptTag.textContent);

            // Sincronizar datos reales devueltos por el servidor con el LocalStorage (por si cargó desde URL vacía)
            let currentList = getCompareList();
            const storedIndex = currentList.findIndex(i => i.handle === item.handle);
            if (storedIndex !== -1 && (currentList[storedIndex].id === null || currentList[storedIndex].image.startsWith('data:'))) {
              currentList[storedIndex].id = data.id;
              currentList[storedIndex].title = data.title;
              currentList[storedIndex].image = data.image;
              localStorage.setItem(STORAGE_KEY, JSON.stringify(currentList));
              syncFloatingBarThumbnails(currentList);
            }

            return data;
          })
          .catch(err => {
            console.error(err);
            return {
              title: item.title,
              handle: item.handle,
              image: item.image,
              price: 'No disponible',
              available: false,
              key_specs: [],
              specs: {}
            };
          });
      });

      const productsData = await Promise.all(promises);

      // Filas PRINCIPALES (curadas por familia en snippets/lg-compare-specs.liquid),
      // alineadas por id entre productos; el orden es el de aparición.
      const keyRows = [];
      productsData.forEach(p => {
        (p.key_specs || []).forEach(ks => {
          if (!keyRows.some(r => r.id === ks.id)) keyRows.push({ id: ks.id, label: ks.label });
        });
      });

      // Resto de metacampos («Ver todas las características»), sin repetir etiquetas ya mostradas
      const shownLabels = keyRows.map(r => r.label.toLowerCase());
      const allSpecKeys = [];
      productsData.forEach(p => {
        if (p.specs) {
          Object.keys(p.specs).forEach(key => {
            if (!allSpecKeys.includes(key) && !shownLabels.includes(key.toLowerCase())) {
              allSpecKeys.push(key);
            }
          });
        }
      });

      // Construir cabecera e imágenes
      let headerHTML = `<tr class="lg-compare-table-header-row">`;
      headerHTML += `<th class="lg-compare-corner"></th>`; 
      
      productsData.forEach(p => {
        headerHTML += `
          <th class="lg-compare-column">
            <div class="lg-compare-card-header">
              <button type="button" class="lg-compare-card-header__remove" data-handle="${p.handle}" title="Quitar de la lista">✕</button>
              <img class="lg-compare-card-header__image" src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy">
              <p class="lg-compare-card-header__vendor">${esc(p.vendor || 'LuzGuru')}</p>
              <h4 class="lg-compare-card-header__title"><a href="${esc(p.url || '#')}">${esc(p.title)}</a></h4>
              <div class="lg-compare-card-header__price-box">
                <span class="lg-compare-card-header__price">${p.price}</span>
                ${p.compare_at_price ? `<span class="lg-compare-card-header__price-compare">${p.compare_at_price}</span>` : ''}
              </div>
            </div>
          </th>
        `;
      });
      headerHTML += `</tr>`;

      // Fila de acciones (Botón comprar)
      let actionHTML = `<tr>`;
      actionHTML += `<th class="lg-compare-row-header lg-compare-action-cell">Acciones</th>`;
      productsData.forEach(p => {
        actionHTML += `
          <td class="lg-compare-action-cell">
            <a href="${p.url || '#'}" class="lg-compare-btn-buy">
              ${p.available ? 'Ver y Comprar' : 'Agotado'}
            </a>
          </td>
        `;
      });
      actionHTML += `</tr>`;

      // Filas de especificaciones
      // Filas: primero las PRINCIPALES de la familia, después el resto (plegado)
      const specRows = keyRows.map(r => ({
        label: r.label,
        extra: false,
        get: p => {
          const hit = (p.key_specs || []).find(ks => ks.id === r.id);
          return hit ? hit.value : '';
        }
      })).concat(allSpecKeys.map(k => ({
        label: k,
        extra: true,
        get: p => (p.specs && p.specs[k]) || ''
      })));
      let specsHTML = '';
      let extraCount = 0;
      specRows.forEach(srow => {
        const rowValues = productsData.map(p => {
          const val = srow.get(p).trim() || '—';
          return val;
        });
        
        // Filtrar valores vacíos o placeholders (incluyendo em-dash y códigos de escape unicode)
        const validValues = rowValues.filter(val => {
          if (!val) return false;
          const clean = val.trim();
          return clean !== '—' && clean !== '\\u2014' && clean !== '\u2014' && clean !== '-' && clean !== '';
        });
        
        // Sólo renderizar si al menos un producto tiene un valor válido
        if (validValues.length > 0) {
          let rowClass = '';
          if (productsData.length > 1) {
            const firstValid = validValues[0].toLowerCase().replace(/\s+/g, '');
            const allValidEqual = validValues.every(val => val.toLowerCase().replace(/\s+/g, '') === firstValid);
            const hasMissing = validValues.length < productsData.length;
            
            rowClass = (allValidEqual && !hasMissing) ? 'lg-compare-row--equal' : 'lg-compare-row--different';
          }
          if (srow.extra) {
            rowClass = (rowClass + ' lg-compare-row--extra').trim();
            extraCount += 1;
          }
          const rowAttr = rowClass ? ` class="${rowClass}"` : '';

          specsHTML += `<tr${rowAttr}>`;
          specsHTML += `<th class="lg-compare-row-header">${esc(srow.label)}</th>`;
          productsData.forEach(p => {
            const val = esc(srow.get(p)) || '—';
            specsHTML += `<td class="lg-compare-spec-val">${val}</td>`;
          });
          specsHTML += `</tr>`;
        }
      });

      // Ensamblar todo en la tabla
      const tableHTML = `
        <table class="lg-compare-table">
          <thead>
            ${headerHTML}
            ${actionHTML}
          </thead>
          <tbody>
            ${specsHTML}
          </tbody>
        </table>
        ${extraCount > 0 ? `<div class="lg-compare-more"><button type="button" class="lg-compare-more__btn" aria-expanded="false" data-count="${extraCount}">Ver todas las características (${extraCount})</button></div>` : ''}
      `;

      wrapperEl.classList.remove('lg-compare-show-all');
      wrapperEl.innerHTML = tableHTML;

      // Botón "Ver todas las características" (accesible: aria-expanded, teclado nativo)
      const moreBtn = wrapperEl.querySelector('.lg-compare-more__btn');
      if (moreBtn) {
        moreBtn.addEventListener('click', () => {
          const open = wrapperEl.classList.toggle('lg-compare-show-all');
          moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          moreBtn.textContent = open
            ? 'Mostrar solo las principales'
            : `Ver todas las características (${moreBtn.dataset.count})`;
        });
      }

      // Enlazar los botones de eliminar del header del modal / tabla
      wrapperEl.querySelectorAll('.lg-compare-card-header__remove').forEach(btn => {
        btn.addEventListener('click', (e) => {
          removeProduct(btn.dataset.handle);
        });
      });

    } catch (e) {
      console.error(e);
      wrapperEl.innerHTML = `
        <div class="lg-compare-empty">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <p>Ocurrió un error al procesar la tabla de comparación. Por favor, reinténtalo.</p>
        </div>
      `;
    } finally {
      loaderEl.setAttribute('hidden', 'true');
      wrapperEl.style.opacity = '1';
    }
  }

  // Delegación de eventos para los botones de comparar
  function initEventDelegation() {
    document.body.addEventListener('click', (e) => {
      const btn = e.target.closest('.lg-compare-btn-toggle, .lg-compare-card-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const id = btn.dataset.id;
      const handle = btn.dataset.handle;
      const title = btn.dataset.title || '';
      const image = btn.dataset.image || '';

      const list = getCompareList();
      const isAlreadyAdded = list.some(item => item.handle === handle);

      if (isAlreadyAdded) {
        removeProduct(handle);
      } else {
        addProduct(id, handle, title, image, btn, btn.dataset.variantId);
      }
    });
  }

  // Configurar URLs y eventos de compartición en la tabla/modal
  function setupSharing(list) {
    const handles = list.map(item => encodeURIComponent(item.handle)).join(',');
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const cleanRootUrl = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
    const shareUrl = window.location.origin + `${cleanRootUrl}pages/comparar?items=${handles}`;

    const whatsappBtn = document.getElementById('lg-compare-share-whatsapp');
    const emailBtn = document.getElementById('lg-compare-share-email');
    const copyBtn = document.getElementById('lg-compare-share-copy');

    if (whatsappBtn) {
      whatsappBtn.href = 'https://api.whatsapp.com/send?text=' + encodeURIComponent('¡Hola! Echa un vistazo a esta comparación de productos en LuzGuru: ' + shareUrl);
    }

    if (emailBtn) {
      emailBtn.href = 'mailto:?subject=' + encodeURIComponent('Comparación de productos en LuzGuru') + '&body=' + encodeURIComponent('Hola,\n\nQuería compartir contigo esta comparación de productos de LuzGuru. Puedes ver la tabla completa en el siguiente enlace:\n\n' + shareUrl);
    }

    if (copyBtn) {
      // Re-bind click listener
      const newCopyBtn = copyBtn.cloneNode(true);
      copyBtn.parentNode.replaceChild(newCopyBtn, copyBtn);
      
      newCopyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        navigator.clipboard.writeText(shareUrl).then(() => {
          const tooltip = document.getElementById('lg-compare-copy-tooltip');
          if (tooltip) {
            tooltip.textContent = '¡Copiado!';
            newCopyBtn.classList.add('copied');
            setTimeout(() => {
              tooltip.textContent = 'Copiar Enlace';
              newCopyBtn.classList.remove('copied');
            }, 2000);
          }
        });
      });
    }
  }

  // Mostrar banner flotante de importación del comparador
  function showCompareImportBanner(count) {
    const oldBanner = document.getElementById('lg-compare-import-banner');
    if (oldBanner) oldBanner.remove();

    const banner = document.createElement('div');
    banner.id = 'lg-compare-import-banner';
    banner.className = 'lg-wishlist-import-banner'; // Reutiliza la misma clase de estilos del wishlist
    banner.style.bottom = '96px'; // Stacked slightly above the wishlist import banner
    banner.innerHTML = `
      <div class="lg-wishlist-import-banner__content">
        <span class="lg-wishlist-import-banner__sparkle">✦</span>
        <span>Hemos añadido <strong>${count}</strong> productos compartidos al comparador.</span>
      </div>
      <div class="lg-wishlist-import-banner__actions">
        <button type="button" id="lg-compare-banner-open" class="lg-import-banner__btn">Comparar</button>
        <button type="button" id="lg-compare-banner-close" class="lg-import-banner__close" aria-label="Cerrar banner">×</button>
      </div>
    `;

    document.body.appendChild(banner);

    void banner.offsetWidth;
    banner.classList.add('visible');

    const openBtn = banner.querySelector('#lg-compare-banner-open');
    const closeBtn = banner.querySelector('#lg-compare-banner-close');

    if (openBtn) {
      openBtn.addEventListener('click', () => {
        banner.classList.remove('visible');
        setTimeout(() => banner.remove(), 400);
        openComparisonModal();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        banner.classList.remove('visible');
        setTimeout(() => banner.remove(), 400);
      });
    }

    setTimeout(() => {
      if (banner.parentNode) {
        banner.classList.remove('visible');
        setTimeout(() => banner.remove(), 400);
      }
    }, 8000);
  }

  // Animación de vuelo del comparador (hacia el icono de columnas en el header)
  function animateCompareAdd(button) {
    const headerCompare = document.getElementById('compare-icon-bubble');
    if (!headerCompare) return;

    // Burst silver/gold particles around the button
    createCompareParticleBurst(button);

    // Get bounds
    const btnRect = button.getBoundingClientRect();
    const compareRect = headerCompare.getBoundingClientRect();

    // Create floating flyer columns element
    const flyer = document.createElement('div');
    flyer.className = 'lg-compare-flyer';
    flyer.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f8900b" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="3" width="8" height="18" rx="1"/>
        <rect x="14" y="3" width="8" height="18" rx="1"/>
        <path d="M10 12h4"/>
      </svg>
    `;
    
    // Position fixed at click source
    flyer.style.left = `${btnRect.left + btnRect.width / 2 - 12}px`;
    flyer.style.top = `${btnRect.top + btnRect.height / 2 - 12}px`;
    document.body.appendChild(flyer);

    // Force style recalculation
    void flyer.offsetWidth;

    // Trigger translate-scale transition toward target compare icon
    requestAnimationFrame(() => {
      const deltaX = compareRect.left - btnRect.left;
      const deltaY = compareRect.top - btnRect.top;
      flyer.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.2)`;
      flyer.style.opacity = '0.2';
    });

    flyer.addEventListener('transitionend', () => {
      flyer.remove();
      // Add dynamic pulse bounce animation on header compare icon
      headerCompare.classList.remove('lg-pulse-active');
      void headerCompare.offsetWidth; // Trigger reflow
      headerCompare.classList.add('lg-pulse-active');
      setTimeout(() => {
        headerCompare.classList.remove('lg-pulse-active');
      }, 600);
    });
  }

  // Create burst of silver and gold particles on click
  function createCompareParticleBurst(button) {
    const rect = button.getBoundingClientRect();
    const burstCount = 12;
    
    for (let i = 0; i < burstCount; i++) {
      const particle = document.createElement('span');
      particle.className = 'lg-wishlist-particle'; // Reuse particle styling
      
      const isSparkle = Math.random() > 0.5;
      particle.innerHTML = '✦'; // Sparkles
      particle.style.color = isSparkle ? '#e5e5e5' : '#f8900b'; // Silver and gold!
      particle.style.fontSize = `${Math.random() * 8 + 10}px`;
      
      particle.style.left = `${rect.left + rect.width / 2}px`;
      particle.style.top = `${rect.top + rect.height / 2}px`;
      document.body.appendChild(particle);

      const angle = Math.random() * Math.PI * 2;
      const distance = Math.random() * 50 + 20;
      const destX = Math.cos(angle) * distance;
      const destY = Math.sin(angle) * distance;

      void particle.offsetWidth;

      requestAnimationFrame(() => {
        particle.style.transform = `translate(${destX}px, ${destY}px) scale(0)`;
        particle.style.opacity = '0';
      });

      particle.addEventListener('transitionend', () => {
        particle.remove();
      });
    }
  }

  // Inicio de la aplicación
  function init() {
    initDOM();
    initEventDelegation();
    syncFromUrlQuery();
    updateWidgets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
